<template>
  <div class="notification-page">
    <header-pane
      class="notification-page__header"
      colorType="light"
      :pageTitle="$tc('NotificationPage.pageTitle')"
      :hasHeaderNav="hasHeaderNav"
      navigationCurrent="notification"
    />

    <notification-pane class="notification-page__content" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import NotificationPane from '@/components/NotificationPane/NotificationPane.vue'

/**
 * NOTIFICATION 通知ページ
 */
export default defineComponent({
  name: 'NotificationPage',
  components: {
    NotificationPane,
    HeaderPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.notification-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: env(safe-area-inset-bottom);

  &__content {
    height: calc(#{$mypageContentHeightPC} - #{env(safe-area-inset-bottom)});
  }
}
</style>
